const defaultLabels = {
    // Document types
    invoice: 'Invoice',
    creditNote: 'Credit Note',
    quote: 'Quote',
    estimate: 'Estimate',
    receipt: 'Receipt',
    proforma: 'Proforma Invoice',
    packingSlip: 'Packing Slip',
    deliveryNote: 'Delivery Note',
    purchaseOrder: 'Purchase Order',
    storno: 'Storno Invoice',
    refund: 'Refund Invoice',

    // Table headers
    description: 'Description',
    item: 'Item',
    qty: 'Qty',
    unitPrice: 'Unit Price',
    amount: 'Amount',
    gross: 'Gross',
    grossTotal: 'Gross Total',
    vat: 'VAT',
    rate: 'Rate',
    net: 'Net',
    netTotal: 'Net Total',
    totalVat: 'Total VAT',
    total: 'Total',

    // Document sections
    billTo: 'Bill To',
    shipTo: 'Ship To',
    from: 'From',
    to: 'To',
    date: 'Date',
    dueDate: 'Due Date',
    invoiceNumber: 'Invoice No.',
    orderNumber: 'Order No.',
    reference: 'Reference',
    details: 'Details',
    customer: 'Customer',
    vendor: 'Vendor',

    // Totals/summary
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    discount: 'Discount',
    tax: 'Tax',
    paid: 'Paid',
    balance: 'Balance',
    credit: 'Credit',

    // Footer/notes
    bankDetails: 'Bank Details',
    iban: 'IBAN',
    paymentTerms: 'Payment Terms',
    thankYou: 'Thank you for your business!',
    notes: 'Notes',
    terms: 'Terms & Conditions',
    tracking: 'Tracking',

    // Pagination
    page: 'Page',
    of: 'of',
};

const LANGUAGE_PRESETS = [
    {
        code: 'en',
        name: 'English',
        labels: { ...defaultLabels }
    },
    {
        code: 'de',
        name: 'Deutsch',
        labels: {
            invoice: 'Rechnung',
            creditNote: 'Gutschrift',
            quote: 'Angebot',
            estimate: 'Kostenvoranschlag',
            receipt: 'Quittung',
            proforma: 'Proformarechnung',
            packingSlip: 'Packzettel',
            deliveryNote: 'Lieferschein',
            purchaseOrder: 'Bestellung',
            storno: 'Stornorechnung',
            refund: 'Erstattungsrechnung',
            description: 'Beschreibung',
            item: 'Artikel',
            qty: 'Menge',
            unitPrice: 'Einzelpreis',
            amount: 'Betrag',
            gross: 'Brutto',
            grossTotal: 'Brutto Gesamt',
            vat: 'MwSt.',
            rate: 'Satz',
            net: 'Netto',
            netTotal: 'Netto Gesamt',
            totalVat: 'MwSt. Gesamt',
            total: 'Gesamt',
            billTo: 'Rechnungsadresse',
            shipTo: 'Lieferadresse',
            from: 'Von',
            to: 'An',
            date: 'Datum',
            dueDate: 'Fälligkeitsdatum',
            invoiceNumber: 'Rechnungsnr.',
            orderNumber: 'Bestellnr.',
            reference: 'Referenz',
            details: 'Details',
            customer: 'Kunde',
            vendor: 'Lieferant',
            subtotal: 'Zwischensumme',
            shipping: 'Versand',
            discount: 'Rabatt',
            tax: 'Steuer',
            paid: 'Bezahlt',
            balance: 'Restbetrag',
            credit: 'Guthaben',
            bankDetails: 'Bankverbindung',
            iban: 'IBAN',
            paymentTerms: 'Zahlungsbedingungen',
            thankYou: 'Vielen Dank für Ihren Auftrag!',
            notes: 'Hinweise',
            terms: 'Allgemeine Geschäftsbedingungen',
            tracking: 'Sendungsverfolgung',
            page: 'Seite',
            of: 'von',
        }
    },
    {
        code: 'fr',
        name: 'Français',
        labels: {
            invoice: 'Facture',
            creditNote: 'Avoir',
            quote: 'Devis',
            estimate: 'Estimation',
            receipt: 'Reçu',
            proforma: 'Facture Proforma',
            packingSlip: 'Bon de Livraison',
            deliveryNote: 'Bon de Livraison',
            purchaseOrder: 'Bon de Commande',
            storno: 'Facture d\'Annulation',
            refund: 'Facture de Remboursement',
            description: 'Description',
            item: 'Article',
            qty: 'Qté',
            unitPrice: 'Prix Unitaire',
            amount: 'Montant',
            gross: 'Brut',
            grossTotal: 'Total Brut',
            vat: 'TVA',
            rate: 'Taux',
            net: 'Net',
            netTotal: 'Total Net',
            totalVat: 'Total TVA',
            total: 'Total',
            billTo: 'Facturer à',
            shipTo: 'Livrer à',
            from: 'De',
            to: 'À',
            date: 'Date',
            dueDate: 'Date d\'échéance',
            invoiceNumber: 'Facture N°',
            orderNumber: 'Commande N°',
            reference: 'Référence',
            details: 'Détails',
            customer: 'Client',
            vendor: 'Fournisseur',
            subtotal: 'Sous-total',
            shipping: 'Livraison',
            discount: 'Remise',
            tax: 'Taxe',
            paid: 'Payé',
            balance: 'Solde',
            credit: 'Crédit',
            bankDetails: 'Coordonnées Bancaires',
            iban: 'IBAN',
            paymentTerms: 'Conditions de Paiement',
            thankYou: 'Merci pour votre confiance !',
            notes: 'Notes',
            terms: 'Conditions Générales',
            tracking: 'Suivi',
            page: 'Page',
            of: 'de',
        }
    },
    {
        code: 'es',
        name: 'Español',
        labels: {
            invoice: 'Factura',
            creditNote: 'Nota de Crédito',
            quote: 'Cotización',
            estimate: 'Presupuesto',
            receipt: 'Recibo',
            proforma: 'Factura Proforma',
            packingSlip: 'Albarán',
            deliveryNote: 'Nota de Entrega',
            purchaseOrder: 'Orden de Compra',
            storno: 'Factura de Anulación',
            refund: 'Factura de Reembolso',
            description: 'Descripción',
            item: 'Artículo',
            qty: 'Cant.',
            unitPrice: 'Precio Unit.',
            amount: 'Importe',
            gross: 'Bruto',
            grossTotal: 'Total Bruto',
            vat: 'IVA',
            rate: 'Tipo',
            net: 'Neto',
            netTotal: 'Total Neto',
            totalVat: 'Total IVA',
            total: 'Total',
            billTo: 'Facturar a',
            shipTo: 'Enviar a',
            from: 'De',
            to: 'Para',
            date: 'Fecha',
            dueDate: 'Fecha de Vencimiento',
            invoiceNumber: 'Factura N°',
            orderNumber: 'Pedido N°',
            reference: 'Referencia',
            details: 'Detalles',
            customer: 'Cliente',
            vendor: 'Proveedor',
            subtotal: 'Subtotal',
            shipping: 'Envío',
            discount: 'Descuento',
            tax: 'Impuesto',
            paid: 'Pagado',
            balance: 'Saldo',
            credit: 'Crédito',
            bankDetails: 'Datos Bancarios',
            iban: 'IBAN',
            paymentTerms: 'Condiciones de Pago',
            thankYou: '¡Gracias por su compra!',
            notes: 'Notas',
            terms: 'Términos y Condiciones',
            tracking: 'Seguimiento',
            page: 'Página',
            of: 'de',
        }
    },
    {
        code: 'pt',
        name: 'Português',
        labels: {
            invoice: 'Fatura',
            creditNote: 'Nota de Crédito',
            quote: 'Orçamento',
            estimate: 'Estimativa',
            receipt: 'Recibo',
            proforma: 'Fatura Proforma',
            packingSlip: 'Guia de Remessa',
            deliveryNote: 'Nota de Entrega',
            purchaseOrder: 'Ordem de Compra',
            storno: 'Fatura de Estorno',
            refund: 'Fatura de Reembolso',
            description: 'Descrição',
            item: 'Artigo',
            qty: 'Qtd.',
            unitPrice: 'Preço Unit.',
            amount: 'Valor',
            gross: 'Bruto',
            grossTotal: 'Total Bruto',
            vat: 'IVA',
            rate: 'Taxa',
            net: 'Líquido',
            netTotal: 'Total Líquido',
            totalVat: 'Total IVA',
            total: 'Total',
            billTo: 'Faturar a',
            shipTo: 'Enviar a',
            from: 'De',
            to: 'Para',
            date: 'Data',
            dueDate: 'Data de Vencimento',
            invoiceNumber: 'Fatura N°',
            orderNumber: 'Pedido N°',
            reference: 'Referência',
            details: 'Detalhes',
            customer: 'Cliente',
            vendor: 'Fornecedor',
            subtotal: 'Subtotal',
            shipping: 'Frete',
            discount: 'Desconto',
            tax: 'Imposto',
            paid: 'Pago',
            balance: 'Saldo',
            credit: 'Crédito',
            bankDetails: 'Dados Bancários',
            iban: 'IBAN',
            paymentTerms: 'Condições de Pagamento',
            thankYou: 'Obrigado pela preferência!',
            notes: 'Notas',
            terms: 'Termos e Condições',
            tracking: 'Rastreamento',
            page: 'Página',
            of: 'de',
        }
    },
    {
        code: 'it',
        name: 'Italiano',
        labels: {
            invoice: 'Fattura',
            creditNote: 'Nota di Credito',
            quote: 'Preventivo',
            estimate: 'Stima',
            receipt: 'Ricevuta',
            proforma: 'Fattura Proforma',
            packingSlip: 'Bolla di Accompagnamento',
            deliveryNote: 'Nota di Consegna',
            purchaseOrder: 'Ordine di Acquisto',
            storno: 'Fattura di Storno',
            refund: 'Fattura di Rimborso',
            description: 'Descrizione',
            item: 'Articolo',
            qty: 'Qtà',
            unitPrice: 'Prezzo Unit.',
            amount: 'Importo',
            gross: 'Lordo',
            grossTotal: 'Totale Lordo',
            vat: 'IVA',
            rate: 'Aliquota',
            net: 'Netto',
            netTotal: 'Totale Netto',
            totalVat: 'Totale IVA',
            total: 'Totale',
            billTo: 'Fatturare a',
            shipTo: 'Spedire a',
            from: 'Da',
            to: 'A',
            date: 'Data',
            dueDate: 'Data di Scadenza',
            invoiceNumber: 'Fattura N°',
            orderNumber: 'Ordine N°',
            reference: 'Riferimento',
            details: 'Dettagli',
            customer: 'Cliente',
            vendor: 'Fornitore',
            subtotal: 'Subtotale',
            shipping: 'Spedizione',
            discount: 'Sconto',
            tax: 'Imposta',
            paid: 'Pagato',
            balance: 'Saldo',
            credit: 'Credito',
            bankDetails: 'Coordinate Bancarie',
            iban: 'IBAN',
            paymentTerms: 'Condizioni di Pagamento',
            thankYou: 'Grazie per il vostro acquisto!',
            notes: 'Note',
            terms: 'Termini e Condizioni',
            tracking: 'Tracciamento',
            page: 'Pagina',
            of: 'di',
        }
    },
    {
        code: 'nl',
        name: 'Nederlands',
        labels: {
            invoice: 'Factuur',
            creditNote: 'Creditnota',
            quote: 'Offerte',
            estimate: 'Schatting',
            receipt: 'Bon',
            proforma: 'Proformafactuur',
            packingSlip: 'Pakbon',
            deliveryNote: 'Leveringsbon',
            purchaseOrder: 'Inkooporder',
            storno: 'Stornofactuur',
            refund: 'Terugbetalingsfactuur',
            description: 'Omschrijving',
            item: 'Artikel',
            qty: 'Aantal',
            unitPrice: 'Stukprijs',
            amount: 'Bedrag',
            gross: 'Bruto',
            grossTotal: 'Bruto Totaal',
            vat: 'BTW',
            rate: 'Tarief',
            net: 'Netto',
            netTotal: 'Netto Totaal',
            totalVat: 'Totaal BTW',
            total: 'Totaal',
            billTo: 'Factuuradres',
            shipTo: 'Afleveradres',
            from: 'Van',
            to: 'Aan',
            date: 'Datum',
            dueDate: 'Vervaldatum',
            invoiceNumber: 'Factuurnr.',
            orderNumber: 'Ordernr.',
            reference: 'Referentie',
            details: 'Details',
            customer: 'Klant',
            vendor: 'Leverancier',
            subtotal: 'Subtotaal',
            shipping: 'Verzending',
            discount: 'Korting',
            tax: 'Belasting',
            paid: 'Betaald',
            balance: 'Openstaand',
            credit: 'Tegoed',
            bankDetails: 'Bankgegevens',
            iban: 'IBAN',
            paymentTerms: 'Betalingsvoorwaarden',
            thankYou: 'Bedankt voor uw bestelling!',
            notes: 'Opmerkingen',
            terms: 'Algemene Voorwaarden',
            tracking: 'Tracking',
            page: 'Pagina',
            of: 'van',
        }
    },
    {
        code: 'ro',
        name: 'Română',
        labels: {
            invoice: 'Factură',
            creditNote: 'Notă de Credit',
            quote: 'Ofertă',
            estimate: 'Deviz',
            receipt: 'Chitanță',
            proforma: 'Factură Proformă',
            packingSlip: 'Aviz de Expediție',
            deliveryNote: 'Aviz de Însoțire',
            purchaseOrder: 'Comandă de Achiziție',
            storno: 'Factură Stornată',
            refund: 'Factură de Rambursare',
            description: 'Descriere',
            item: 'Articol',
            qty: 'Cant.',
            unitPrice: 'Preț Unitar',
            amount: 'Valoare',
            gross: 'Brut',
            grossTotal: 'Total Brut',
            vat: 'TVA',
            rate: 'Cotă',
            net: 'Net',
            netTotal: 'Total Net',
            totalVat: 'Total TVA',
            total: 'Total',
            billTo: 'Cumpărător',
            shipTo: 'Adresă Livrare',
            from: 'De la',
            to: 'Către',
            date: 'Data',
            dueDate: 'Scadență',
            invoiceNumber: 'Factură Nr.',
            orderNumber: 'Comandă Nr.',
            reference: 'Referință',
            details: 'Detalii',
            customer: 'Client',
            vendor: 'Furnizor',
            subtotal: 'Subtotal',
            shipping: 'Transport',
            discount: 'Reducere',
            tax: 'Taxă',
            paid: 'Plătit',
            balance: 'Sold',
            credit: 'Credit',
            bankDetails: 'Date Bancare',
            iban: 'IBAN',
            paymentTerms: 'Condiții de Plată',
            thankYou: 'Vă mulțumim!',
            notes: 'Observații',
            terms: 'Termeni și Condiții',
            tracking: 'Urmărire',
            page: 'Pagina',
            of: 'din',
        }
    },
    {
        code: 'pl',
        name: 'Polski',
        labels: {
            invoice: 'Faktura',
            creditNote: 'Nota Kredytowa',
            quote: 'Wycena',
            estimate: 'Kosztorys',
            receipt: 'Paragon',
            proforma: 'Faktura Proforma',
            packingSlip: 'List Przewozowy',
            deliveryNote: 'Dowód Dostawy',
            purchaseOrder: 'Zamówienie',
            storno: 'Faktura Storno',
            refund: 'Faktura Korygująca',
            description: 'Opis',
            item: 'Pozycja',
            qty: 'Ilość',
            unitPrice: 'Cena Jedn.',
            amount: 'Kwota',
            gross: 'Brutto',
            grossTotal: 'Razem Brutto',
            vat: 'VAT',
            rate: 'Stawka',
            net: 'Netto',
            netTotal: 'Razem Netto',
            totalVat: 'Razem VAT',
            total: 'Razem',
            billTo: 'Nabywca',
            shipTo: 'Adres Dostawy',
            from: 'Od',
            to: 'Do',
            date: 'Data',
            dueDate: 'Termin Płatności',
            invoiceNumber: 'Faktura Nr',
            orderNumber: 'Zamówienie Nr',
            reference: 'Nr Referencyjny',
            details: 'Szczegóły',
            customer: 'Klient',
            vendor: 'Dostawca',
            subtotal: 'Suma Częściowa',
            shipping: 'Wysyłka',
            discount: 'Rabat',
            tax: 'Podatek',
            paid: 'Zapłacono',
            balance: 'Do Zapłaty',
            credit: 'Kredyt',
            bankDetails: 'Dane Bankowe',
            iban: 'IBAN',
            paymentTerms: 'Warunki Płatności',
            thankYou: 'Dziękujemy za zakupy!',
            notes: 'Uwagi',
            terms: 'Regulamin',
            tracking: 'Śledzenie',
            page: 'Strona',
            of: 'z',
        }
    },
    {
        code: 'cs',
        name: 'Čeština (Czech)',
        labels: {
            invoice: 'Faktura',
            creditNote: 'Dobropis',
            quote: 'Nabídka',
            estimate: 'Odhad',
            receipt: 'Příjmový doklad',
            proforma: 'Proforma faktura',
            packingSlip: 'Dodací list',
            deliveryNote: 'Dodací list',
            purchaseOrder: 'Objednávka',
            storno: 'Storno faktura',
            refund: 'Faktura na vrácení',
            description: 'Popis',
            item: 'Položka',
            qty: 'Množství',
            unitPrice: 'Jedn. cena',
            amount: 'Částka',
            gross: 'Hrubá',
            grossTotal: 'Celkem hrubá',
            vat: 'DPH',
            rate: 'Sazba',
            net: 'Čistá',
            netTotal: 'Celkem čistá',
            totalVat: 'Celkem DPH',
            total: 'Celkem',
            billTo: 'Odběratel',
            shipTo: 'Doručovací adresa',
            from: 'Od',
            to: 'Pro',
            date: 'Datum',
            dueDate: 'Datum splatnosti',
            invoiceNumber: 'Faktura č.',
            orderNumber: 'Objednávka č.',
            reference: 'Reference',
            details: 'Podrobnosti',
            customer: 'Zákazník',
            vendor: 'Dodavatel',
            subtotal: 'Mezisoučet',
            shipping: 'Doprava',
            discount: 'Sleva',
            tax: 'Daň',
            paid: 'Zaplaceno',
            balance: 'Zůstatek',
            credit: 'Kredit',
            bankDetails: 'Bankovní údaje',
            iban: 'IBAN',
            paymentTerms: 'Platební podmínky',
            thankYou: 'Děkujeme za Váš nákup!',
            notes: 'Poznámky',
            terms: 'Obchodní podmínky',
            tracking: 'Sledování',
            page: 'Strana',
            of: 'z',
        }
    },
    {
        code: 'sk',
        name: 'Slovenčina (Slovak)',
        labels: {
            invoice: 'Faktúra',
            creditNote: 'Dobropis',
            quote: 'Cenová ponuka',
            estimate: 'Odhad',
            receipt: 'Príjmový doklad',
            proforma: 'Proforma faktúra',
            packingSlip: 'Dodací list',
            deliveryNote: 'Dodací list',
            purchaseOrder: 'Objednávka',
            storno: 'Storno faktúra',
            refund: 'Faktúra na vrátenie',
            description: 'Popis',
            item: 'Položka',
            qty: 'Množstvo',
            unitPrice: 'Jedn. cena',
            amount: 'Suma',
            gross: 'Hrubá',
            grossTotal: 'Celkom hrubá',
            vat: 'DPH',
            rate: 'Sadzba',
            net: 'Čistá',
            netTotal: 'Celkom čistá',
            totalVat: 'Celkom DPH',
            total: 'Celkom',
            billTo: 'Odberateľ',
            shipTo: 'Dodacia adresa',
            from: 'Od',
            to: 'Pre',
            date: 'Dátum',
            dueDate: 'Dátum splatnosti',
            invoiceNumber: 'Faktúra č.',
            orderNumber: 'Objednávka č.',
            reference: 'Referencia',
            details: 'Podrobnosti',
            customer: 'Zákazník',
            vendor: 'Dodávateľ',
            subtotal: 'Medzisúčet',
            shipping: 'Doprava',
            discount: 'Zľava',
            tax: 'Daň',
            paid: 'Zaplatené',
            balance: 'Zostatok',
            credit: 'Kredit',
            bankDetails: 'Bankové údaje',
            iban: 'IBAN',
            paymentTerms: 'Platobné podmienky',
            thankYou: 'Ďakujeme za Váš nákup!',
            notes: 'Poznámky',
            terms: 'Obchodné podmienky',
            tracking: 'Sledovanie',
            page: 'Strana',
            of: 'z',
        }
    },
    {
        code: 'hu',
        name: 'Magyar (Hungarian)',
        labels: {
            invoice: 'Számla',
            creditNote: 'Jóváírás',
            quote: 'Árajánlat',
            estimate: 'Becslés',
            receipt: 'Nyugta',
            proforma: 'Proforma számla',
            packingSlip: 'Csomagolási jegyzék',
            deliveryNote: 'Szállítólevél',
            purchaseOrder: 'Megrendelés',
            storno: 'Sztornó számla',
            refund: 'Visszatérítés számla',
            description: 'Leírás',
            item: 'Tétel',
            qty: 'Menny.',
            unitPrice: 'Egységár',
            amount: 'Összeg',
            gross: 'Bruttó',
            grossTotal: 'Bruttó összesen',
            vat: 'ÁFA',
            rate: 'Kulcs',
            net: 'Nettó',
            netTotal: 'Nettó összesen',
            totalVat: 'ÁFA összesen',
            total: 'Összesen',
            billTo: 'Vevő',
            shipTo: 'Szállítási cím',
            from: 'Feladó',
            to: 'Címzett',
            date: 'Dátum',
            dueDate: 'Fizetési határidő',
            invoiceNumber: 'Számlaszám',
            orderNumber: 'Rendelésszám',
            reference: 'Hivatkozás',
            details: 'Részletek',
            customer: 'Vevő',
            vendor: 'Szállító',
            subtotal: 'Részösszeg',
            shipping: 'Szállítás',
            discount: 'Kedvezmény',
            tax: 'Adó',
            paid: 'Fizetve',
            balance: 'Egyenleg',
            credit: 'Jóváírás',
            bankDetails: 'Bankadatok',
            iban: 'IBAN',
            paymentTerms: 'Fizetési feltételek',
            thankYou: 'Köszönjük a vásárlást!',
            notes: 'Megjegyzések',
            terms: 'Általános Szerződési Feltételek',
            tracking: 'Nyomkövetés',
            page: 'Oldal',
            of: '/',
        }
    },
    {
        code: 'el',
        name: 'Ελληνικά (Greek)',
        labels: {
            invoice: 'Τιμολόγιο',
            creditNote: 'Πιστωτικό Σημείωμα',
            quote: 'Προσφορά',
            estimate: 'Εκτίμηση',
            receipt: 'Απόδειξη',
            proforma: 'Προτιμολόγιο',
            packingSlip: 'Δελτίο Αποστολής',
            deliveryNote: 'Δελτίο Παράδοσης',
            purchaseOrder: 'Παραγγελία',
            storno: 'Ακυρωτικό Τιμολόγιο',
            refund: 'Τιμολόγιο Επιστροφής',
            description: 'Περιγραφή',
            item: 'Είδος',
            qty: 'Ποσ.',
            unitPrice: 'Τιμή Μονάδας',
            amount: 'Ποσό',
            gross: 'Μεικτό',
            grossTotal: 'Σύνολο Μεικτού',
            vat: 'ΦΠΑ',
            rate: 'Συντελεστής',
            net: 'Καθαρό',
            netTotal: 'Σύνολο Καθαρού',
            totalVat: 'Σύνολο ΦΠΑ',
            total: 'Σύνολο',
            billTo: 'Προς',
            shipTo: 'Αποστολή σε',
            from: 'Από',
            to: 'Προς',
            date: 'Ημερομηνία',
            dueDate: 'Ημ. Λήξης',
            invoiceNumber: 'Αρ. Τιμολογίου',
            orderNumber: 'Αρ. Παραγγελίας',
            reference: 'Αναφορά',
            details: 'Λεπτομέρειες',
            customer: 'Πελάτης',
            vendor: 'Προμηθευτής',
            subtotal: 'Υποσύνολο',
            shipping: 'Μεταφορικά',
            discount: 'Έκπτωση',
            tax: 'Φόρος',
            paid: 'Πληρωμένο',
            balance: 'Υπόλοιπο',
            credit: 'Πίστωση',
            bankDetails: 'Τραπεζικά Στοιχεία',
            iban: 'IBAN',
            paymentTerms: 'Όροι Πληρωμής',
            thankYou: 'Ευχαριστούμε για την προτίμησή σας!',
            notes: 'Σημειώσεις',
            terms: 'Όροι & Προϋποθέσεις',
            tracking: 'Παρακολούθηση',
            page: 'Σελίδα',
            of: 'από',
        }
    },
    {
        code: 'bg',
        name: 'Български (Bulgarian)',
        labels: {
            invoice: 'Фактура',
            creditNote: 'Кредитно известие',
            quote: 'Оферта',
            estimate: 'Проформа',
            receipt: 'Разписка',
            proforma: 'Проформа фактура',
            packingSlip: 'Опаковъчен лист',
            deliveryNote: 'Приемо-предавателен протокол',
            purchaseOrder: 'Поръчка',
            storno: 'Сторно фактура',
            refund: 'Фактура за възстановяване',
            description: 'Описание',
            item: 'Артикул',
            qty: 'К-во',
            unitPrice: 'Ед. цена',
            amount: 'Сума',
            gross: 'Бруто',
            grossTotal: 'Общо бруто',
            vat: 'ДДС',
            rate: 'Ставка',
            net: 'Нето',
            netTotal: 'Общо нето',
            totalVat: 'Общо ДДС',
            total: 'Общо',
            billTo: 'Получател',
            shipTo: 'Адрес за доставка',
            from: 'От',
            to: 'До',
            date: 'Дата',
            dueDate: 'Краен срок',
            invoiceNumber: 'Фактура №',
            orderNumber: 'Поръчка №',
            reference: 'Референция',
            details: 'Детайли',
            customer: 'Клиент',
            vendor: 'Доставчик',
            subtotal: 'Междинна сума',
            shipping: 'Доставка',
            discount: 'Отстъпка',
            tax: 'Данък',
            paid: 'Платено',
            balance: 'Салдо',
            credit: 'Кредит',
            bankDetails: 'Банкови данни',
            iban: 'IBAN',
            paymentTerms: 'Условия за плащане',
            thankYou: 'Благодарим Ви!',
            notes: 'Бележки',
            terms: 'Общи условия',
            tracking: 'Проследяване',
            page: 'Страница',
            of: 'от',
        }
    },
    {
        code: 'hr',
        name: 'Hrvatski (Croatian)',
        labels: {
            invoice: 'Račun',
            creditNote: 'Odobrenje',
            quote: 'Ponuda',
            estimate: 'Procjena',
            receipt: 'Potvrda',
            proforma: 'Predračun',
            packingSlip: 'Otpremnica',
            deliveryNote: 'Dostavnica',
            purchaseOrder: 'Narudžbenica',
            storno: 'Storno račun',
            refund: 'Račun za povrat',
            description: 'Opis',
            item: 'Stavka',
            qty: 'Kol.',
            unitPrice: 'Jed. cijena',
            amount: 'Iznos',
            gross: 'Bruto',
            grossTotal: 'Ukupno bruto',
            vat: 'PDV',
            rate: 'Stopa',
            net: 'Neto',
            netTotal: 'Ukupno neto',
            totalVat: 'Ukupno PDV',
            total: 'Ukupno',
            billTo: 'Kupac',
            shipTo: 'Adresa dostave',
            from: 'Od',
            to: 'Za',
            date: 'Datum',
            dueDate: 'Rok plaćanja',
            invoiceNumber: 'Račun br.',
            orderNumber: 'Narudžba br.',
            reference: 'Referenca',
            details: 'Pojedinosti',
            customer: 'Kupac',
            vendor: 'Dobavljač',
            subtotal: 'Međuzbroj',
            shipping: 'Dostava',
            discount: 'Popust',
            tax: 'Porez',
            paid: 'Plaćeno',
            balance: 'Saldo',
            credit: 'Odobrenje',
            bankDetails: 'Bankovni podaci',
            iban: 'IBAN',
            paymentTerms: 'Uvjeti plaćanja',
            thankYou: 'Hvala na kupovini!',
            notes: 'Napomene',
            terms: 'Uvjeti poslovanja',
            tracking: 'Praćenje',
            page: 'Stranica',
            of: 'od',
        }
    },
    {
        code: 'sr',
        name: 'Srpski (Serbian)',
        labels: {
            invoice: 'Faktura',
            creditNote: 'Knjižno odobrenje',
            quote: 'Ponuda',
            estimate: 'Predračun',
            receipt: 'Priznanica',
            proforma: 'Profaktura',
            packingSlip: 'Otpremnica',
            deliveryNote: 'Dostavnica',
            purchaseOrder: 'Narudžbenica',
            storno: 'Storno faktura',
            refund: 'Faktura za povraćaj',
            description: 'Opis',
            item: 'Stavka',
            qty: 'Kol.',
            unitPrice: 'Jed. cena',
            amount: 'Iznos',
            gross: 'Bruto',
            grossTotal: 'Ukupno bruto',
            vat: 'PDV',
            rate: 'Stopa',
            net: 'Neto',
            netTotal: 'Ukupno neto',
            totalVat: 'Ukupno PDV',
            total: 'Ukupno',
            billTo: 'Kupac',
            shipTo: 'Adresa isporuke',
            from: 'Od',
            to: 'Za',
            date: 'Datum',
            dueDate: 'Rok plaćanja',
            invoiceNumber: 'Faktura br.',
            orderNumber: 'Narudžbina br.',
            reference: 'Referenca',
            details: 'Detalji',
            customer: 'Kupac',
            vendor: 'Dobavljač',
            subtotal: 'Međuzbir',
            shipping: 'Dostava',
            discount: 'Popust',
            tax: 'Porez',
            paid: 'Plaćeno',
            balance: 'Saldo',
            credit: 'Odobrenje',
            bankDetails: 'Bankarski podaci',
            iban: 'IBAN',
            paymentTerms: 'Uslovi plaćanja',
            thankYou: 'Hvala na kupovini!',
            notes: 'Napomene',
            terms: 'Uslovi poslovanja',
            tracking: 'Praćenje',
            page: 'Strana',
            of: 'od',
        }
    },
    {
        code: 'sl',
        name: 'Slovenščina (Slovenian)',
        labels: {
            invoice: 'Račun',
            creditNote: 'Dobropis',
            quote: 'Ponudba',
            estimate: 'Ocena',
            receipt: 'Potrdilo',
            proforma: 'Predračun',
            packingSlip: 'Dobavnica',
            deliveryNote: 'Dobavnica',
            purchaseOrder: 'Naročilnica',
            storno: 'Storno račun',
            refund: 'Račun za vračilo',
            description: 'Opis',
            item: 'Postavka',
            qty: 'Kol.',
            unitPrice: 'Cena/enoto',
            amount: 'Znesek',
            gross: 'Bruto',
            grossTotal: 'Skupaj bruto',
            vat: 'DDV',
            rate: 'Stopnja',
            net: 'Neto',
            netTotal: 'Skupaj neto',
            totalVat: 'Skupaj DDV',
            total: 'Skupaj',
            billTo: 'Kupec',
            shipTo: 'Naslov dostave',
            from: 'Od',
            to: 'Za',
            date: 'Datum',
            dueDate: 'Rok plačila',
            invoiceNumber: 'Račun št.',
            orderNumber: 'Naročilo št.',
            reference: 'Referenca',
            details: 'Podrobnosti',
            customer: 'Stranka',
            vendor: 'Dobavitelj',
            subtotal: 'Vmesni seštevek',
            shipping: 'Dostava',
            discount: 'Popust',
            tax: 'Davek',
            paid: 'Plačano',
            balance: 'Stanje',
            credit: 'Dobropis',
            bankDetails: 'Bančni podatki',
            iban: 'IBAN',
            paymentTerms: 'Plačilni pogoji',
            thankYou: 'Hvala za nakup!',
            notes: 'Opombe',
            terms: 'Splošni pogoji',
            tracking: 'Sledenje',
            page: 'Stran',
            of: 'od',
        }
    },
    {
        code: 'da',
        name: 'Dansk (Danish)',
        labels: {
            invoice: 'Faktura',
            creditNote: 'Kreditnota',
            quote: 'Tilbud',
            estimate: 'Overslag',
            receipt: 'Kvittering',
            proforma: 'Proformafaktura',
            packingSlip: 'Følgeseddel',
            deliveryNote: 'Leveringsseddel',
            purchaseOrder: 'Indkøbsordre',
            storno: 'Stornofaktura',
            refund: 'Tilbagebetalingsfaktura',
            description: 'Beskrivelse',
            item: 'Vare',
            qty: 'Antal',
            unitPrice: 'Enhedspris',
            amount: 'Beløb',
            gross: 'Brutto',
            grossTotal: 'Brutto i alt',
            vat: 'Moms',
            rate: 'Sats',
            net: 'Netto',
            netTotal: 'Netto i alt',
            totalVat: 'Moms i alt',
            total: 'I alt',
            billTo: 'Faktureres til',
            shipTo: 'Leveres til',
            from: 'Fra',
            to: 'Til',
            date: 'Dato',
            dueDate: 'Forfaldsdato',
            invoiceNumber: 'Fakturanr.',
            orderNumber: 'Ordrenr.',
            reference: 'Reference',
            details: 'Detaljer',
            customer: 'Kunde',
            vendor: 'Leverandør',
            subtotal: 'Subtotal',
            shipping: 'Fragt',
            discount: 'Rabat',
            tax: 'Skat',
            paid: 'Betalt',
            balance: 'Saldo',
            credit: 'Kredit',
            bankDetails: 'Bankoplysninger',
            iban: 'IBAN',
            paymentTerms: 'Betalingsbetingelser',
            thankYou: 'Tak for din ordre!',
            notes: 'Bemærkninger',
            terms: 'Handelsbetingelser',
            tracking: 'Sporing',
            page: 'Side',
            of: 'af',
        }
    },
    {
        code: 'sv',
        name: 'Svenska (Swedish)',
        labels: {
            invoice: 'Faktura',
            creditNote: 'Kreditnota',
            quote: 'Offert',
            estimate: 'Uppskattning',
            receipt: 'Kvitto',
            proforma: 'Proformafaktura',
            packingSlip: 'Följesedel',
            deliveryNote: 'Leveranssedel',
            purchaseOrder: 'Inköpsorder',
            storno: 'Stornofaktura',
            refund: 'Återbetalningsfaktura',
            description: 'Beskrivning',
            item: 'Artikel',
            qty: 'Antal',
            unitPrice: 'Á-pris',
            amount: 'Belopp',
            gross: 'Brutto',
            grossTotal: 'Brutto totalt',
            vat: 'Moms',
            rate: 'Sats',
            net: 'Netto',
            netTotal: 'Netto totalt',
            totalVat: 'Moms totalt',
            total: 'Totalt',
            billTo: 'Faktureras',
            shipTo: 'Leveransadress',
            from: 'Från',
            to: 'Till',
            date: 'Datum',
            dueDate: 'Förfallodatum',
            invoiceNumber: 'Fakturanr.',
            orderNumber: 'Ordernr.',
            reference: 'Referens',
            details: 'Detaljer',
            customer: 'Kund',
            vendor: 'Leverantör',
            subtotal: 'Delsumma',
            shipping: 'Frakt',
            discount: 'Rabatt',
            tax: 'Skatt',
            paid: 'Betald',
            balance: 'Saldo',
            credit: 'Kredit',
            bankDetails: 'Bankuppgifter',
            iban: 'IBAN',
            paymentTerms: 'Betalningsvillkor',
            thankYou: 'Tack för din beställning!',
            notes: 'Anteckningar',
            terms: 'Villkor',
            tracking: 'Spårning',
            page: 'Sida',
            of: 'av',
        }
    },
    {
        code: 'no',
        name: 'Norsk (Norwegian)',
        labels: {
            invoice: 'Faktura',
            creditNote: 'Kreditnota',
            quote: 'Tilbud',
            estimate: 'Estimat',
            receipt: 'Kvittering',
            proforma: 'Proformafaktura',
            packingSlip: 'Pakkseddel',
            deliveryNote: 'Følgeseddel',
            purchaseOrder: 'Innkjøpsordre',
            storno: 'Stornofaktura',
            refund: 'Tilbakebetalingsfaktura',
            description: 'Beskrivelse',
            item: 'Vare',
            qty: 'Antall',
            unitPrice: 'Enhetspris',
            amount: 'Beløp',
            gross: 'Brutto',
            grossTotal: 'Brutto totalt',
            vat: 'MVA',
            rate: 'Sats',
            net: 'Netto',
            netTotal: 'Netto totalt',
            totalVat: 'MVA totalt',
            total: 'Totalt',
            billTo: 'Faktureres til',
            shipTo: 'Leveringsadresse',
            from: 'Fra',
            to: 'Til',
            date: 'Dato',
            dueDate: 'Forfallsdato',
            invoiceNumber: 'Fakturanr.',
            orderNumber: 'Ordrenr.',
            reference: 'Referanse',
            details: 'Detaljer',
            customer: 'Kunde',
            vendor: 'Leverandør',
            subtotal: 'Delsum',
            shipping: 'Frakt',
            discount: 'Rabatt',
            tax: 'Skatt',
            paid: 'Betalt',
            balance: 'Saldo',
            credit: 'Kredit',
            bankDetails: 'Bankopplysninger',
            iban: 'IBAN',
            paymentTerms: 'Betalingsbetingelser',
            thankYou: 'Takk for handelen!',
            notes: 'Merknader',
            terms: 'Vilkår',
            tracking: 'Sporing',
            page: 'Side',
            of: 'av',
        }
    },
    {
        code: 'fi',
        name: 'Suomi (Finnish)',
        labels: {
            invoice: 'Lasku',
            creditNote: 'Hyvityslasku',
            quote: 'Tarjous',
            estimate: 'Arvio',
            receipt: 'Kuitti',
            proforma: 'Proformalaskku',
            packingSlip: 'Pakkauslista',
            deliveryNote: 'Lähetysluettelo',
            purchaseOrder: 'Ostotilaus',
            storno: 'Peruutuslasku',
            refund: 'Palautuslasku',
            description: 'Kuvaus',
            item: 'Tuote',
            qty: 'Määrä',
            unitPrice: 'Yksikköhinta',
            amount: 'Summa',
            gross: 'Brutto',
            grossTotal: 'Brutto yhteensä',
            vat: 'ALV',
            rate: 'Vero%',
            net: 'Netto',
            netTotal: 'Netto yhteensä',
            totalVat: 'ALV yhteensä',
            total: 'Yhteensä',
            billTo: 'Laskutettava',
            shipTo: 'Toimitusosoite',
            from: 'Lähettäjä',
            to: 'Vastaanottaja',
            date: 'Päivämäärä',
            dueDate: 'Eräpäivä',
            invoiceNumber: 'Laskun nro',
            orderNumber: 'Tilausnro',
            reference: 'Viite',
            details: 'Tiedot',
            customer: 'Asiakas',
            vendor: 'Toimittaja',
            subtotal: 'Välisumma',
            shipping: 'Toimitus',
            discount: 'Alennus',
            tax: 'Vero',
            paid: 'Maksettu',
            balance: 'Saldo',
            credit: 'Hyvitys',
            bankDetails: 'Pankkitiedot',
            iban: 'IBAN',
            paymentTerms: 'Maksuehdot',
            thankYou: 'Kiitos tilauksestasi!',
            notes: 'Huomautukset',
            terms: 'Ehdot',
            tracking: 'Seuranta',
            page: 'Sivu',
            of: '/',
        }
    },
    {
        code: 'lt',
        name: 'Lietuvių (Lithuanian)',
        labels: {
            invoice: 'Sąskaita faktūra',
            creditNote: 'Kreditinė sąskaita',
            quote: 'Pasiūlymas',
            estimate: 'Sąmata',
            receipt: 'Kvitas',
            proforma: 'Išankstinė sąskaita',
            packingSlip: 'Pakavimo lapas',
            deliveryNote: 'Pristatymo dokumentas',
            purchaseOrder: 'Užsakymas',
            storno: 'Storno sąskaita',
            refund: 'Grąžinimo sąskaita',
            description: 'Aprašymas',
            item: 'Prekė',
            qty: 'Kiekis',
            unitPrice: 'Vnt. kaina',
            amount: 'Suma',
            gross: 'Su PVM',
            grossTotal: 'Viso su PVM',
            vat: 'PVM',
            rate: 'Tarifas',
            net: 'Be PVM',
            netTotal: 'Viso be PVM',
            totalVat: 'PVM viso',
            total: 'Viso',
            billTo: 'Pirkėjas',
            shipTo: 'Pristatymo adresas',
            from: 'Nuo',
            to: 'Kam',
            date: 'Data',
            dueDate: 'Mokėjimo terminas',
            invoiceNumber: 'Sąskaitos Nr.',
            orderNumber: 'Užsakymo Nr.',
            reference: 'Nuoroda',
            details: 'Informacija',
            customer: 'Klientas',
            vendor: 'Tiekėjas',
            subtotal: 'Tarpinė suma',
            shipping: 'Pristatymas',
            discount: 'Nuolaida',
            tax: 'Mokestis',
            paid: 'Apmokėta',
            balance: 'Likutis',
            credit: 'Kreditas',
            bankDetails: 'Banko rekvizitai',
            iban: 'IBAN',
            paymentTerms: 'Mokėjimo sąlygos',
            thankYou: 'Dėkojame už pirkimą!',
            notes: 'Pastabos',
            terms: 'Sąlygos',
            tracking: 'Sekimas',
            page: 'Puslapis',
            of: 'iš',
        }
    },
    {
        code: 'lv',
        name: 'Latviešu (Latvian)',
        labels: {
            invoice: 'Rēķins',
            creditNote: 'Kredītrēķins',
            quote: 'Piedāvājums',
            estimate: 'Tāme',
            receipt: 'Kvīts',
            proforma: 'Priekšapmaksas rēķins',
            packingSlip: 'Pavadzīme',
            deliveryNote: 'Piegādes dokuments',
            purchaseOrder: 'Pasūtījums',
            storno: 'Storno rēķins',
            refund: 'Atmaksas rēķins',
            description: 'Apraksts',
            item: 'Prece',
            qty: 'Daudzums',
            unitPrice: 'Vien. cena',
            amount: 'Summa',
            gross: 'Bruto',
            grossTotal: 'Bruto kopā',
            vat: 'PVN',
            rate: 'Likme',
            net: 'Neto',
            netTotal: 'Neto kopā',
            totalVat: 'PVN kopā',
            total: 'Kopā',
            billTo: 'Pircējs',
            shipTo: 'Piegādes adrese',
            from: 'No',
            to: 'Kam',
            date: 'Datums',
            dueDate: 'Apmaksas termiņš',
            invoiceNumber: 'Rēķina Nr.',
            orderNumber: 'Pasūtījuma Nr.',
            reference: 'Atsauce',
            details: 'Detaļas',
            customer: 'Klients',
            vendor: 'Piegādātājs',
            subtotal: 'Starpsumma',
            shipping: 'Piegāde',
            discount: 'Atlaide',
            tax: 'Nodoklis',
            paid: 'Samaksāts',
            balance: 'Atlikums',
            credit: 'Kredīts',
            bankDetails: 'Bankas rekvizīti',
            iban: 'IBAN',
            paymentTerms: 'Maksājuma noteikumi',
            thankYou: 'Paldies par pirkumu!',
            notes: 'Piezīmes',
            terms: 'Noteikumi',
            tracking: 'Izsekošana',
            page: 'Lapa',
            of: 'no',
        }
    },
    {
        code: 'et',
        name: 'Eesti (Estonian)',
        labels: {
            invoice: 'Arve',
            creditNote: 'Kreeditarve',
            quote: 'Pakkumine',
            estimate: 'Hinnapakkumine',
            receipt: 'Kviitung',
            proforma: 'Ettemaksuarve',
            packingSlip: 'Saateleht',
            deliveryNote: 'Tarnetõend',
            purchaseOrder: 'Ostutellimus',
            storno: 'Tühistamisarve',
            refund: 'Tagastusarve',
            description: 'Kirjeldus',
            item: 'Toode',
            qty: 'Kogus',
            unitPrice: 'Ühiku hind',
            amount: 'Summa',
            gross: 'Bruto',
            grossTotal: 'Bruto kokku',
            vat: 'KM',
            rate: 'Määr',
            net: 'Neto',
            netTotal: 'Neto kokku',
            totalVat: 'KM kokku',
            total: 'Kokku',
            billTo: 'Ostja',
            shipTo: 'Tarneaadress',
            from: 'Saatja',
            to: 'Saaja',
            date: 'Kuupäev',
            dueDate: 'Maksetähtaeg',
            invoiceNumber: 'Arve nr.',
            orderNumber: 'Tellimuse nr.',
            reference: 'Viitenumber',
            details: 'Andmed',
            customer: 'Klient',
            vendor: 'Tarnija',
            subtotal: 'Vahesumma',
            shipping: 'Transport',
            discount: 'Allahindlus',
            tax: 'Maks',
            paid: 'Tasutud',
            balance: 'Jääk',
            credit: 'Kreedit',
            bankDetails: 'Pangaandmed',
            iban: 'IBAN',
            paymentTerms: 'Maksetingimused',
            thankYou: 'Täname ostu eest!',
            notes: 'Märkused',
            terms: 'Tingimused',
            tracking: 'Jälgimine',
            page: 'Leht',
            of: '/',
        }
    },
    {
        code: 'tr',
        name: 'Türkçe (Turkish)',
        labels: {
            invoice: 'Fatura',
            creditNote: 'Alacak Dekontu',
            quote: 'Teklif',
            estimate: 'Tahmin',
            receipt: 'Makbuz',
            proforma: 'Proforma Fatura',
            packingSlip: 'Sevk İrsaliyesi',
            deliveryNote: 'Teslimat Notu',
            purchaseOrder: 'Sipariş',
            storno: 'İptal Faturası',
            refund: 'İade Faturası',
            description: 'Açıklama',
            item: 'Kalem',
            qty: 'Miktar',
            unitPrice: 'Birim Fiyat',
            amount: 'Tutar',
            gross: 'Brüt',
            grossTotal: 'Brüt Toplam',
            vat: 'KDV',
            rate: 'Oran',
            net: 'Net',
            netTotal: 'Net Toplam',
            totalVat: 'Toplam KDV',
            total: 'Toplam',
            billTo: 'Fatura Adresi',
            shipTo: 'Teslimat Adresi',
            from: 'Gönderen',
            to: 'Alıcı',
            date: 'Tarih',
            dueDate: 'Vade Tarihi',
            invoiceNumber: 'Fatura No',
            orderNumber: 'Sipariş No',
            reference: 'Referans',
            details: 'Detaylar',
            customer: 'Müşteri',
            vendor: 'Tedarikçi',
            subtotal: 'Ara Toplam',
            shipping: 'Kargo',
            discount: 'İndirim',
            tax: 'Vergi',
            paid: 'Ödendi',
            balance: 'Bakiye',
            credit: 'Alacak',
            bankDetails: 'Banka Bilgileri',
            iban: 'IBAN',
            paymentTerms: 'Ödeme Koşulları',
            thankYou: 'Alışverişiniz için teşekkürler!',
            notes: 'Notlar',
            terms: 'Koşullar ve Şartlar',
            tracking: 'Takip',
            page: 'Sayfa',
            of: '/',
        }
    },
    {
        code: 'uk',
        name: 'Українська (Ukrainian)',
        labels: {
            invoice: 'Рахунок',
            creditNote: 'Кредитна нота',
            quote: 'Комерційна пропозиція',
            estimate: 'Кошторис',
            receipt: 'Квитанція',
            proforma: 'Рахунок-проформа',
            packingSlip: 'Пакувальний лист',
            deliveryNote: 'Накладна',
            purchaseOrder: 'Замовлення',
            storno: 'Сторно рахунок',
            refund: 'Рахунок на повернення',
            description: 'Опис',
            item: 'Товар',
            qty: 'К-сть',
            unitPrice: 'Ціна за од.',
            amount: 'Сума',
            gross: 'Брутто',
            grossTotal: 'Загалом брутто',
            vat: 'ПДВ',
            rate: 'Ставка',
            net: 'Нетто',
            netTotal: 'Загалом нетто',
            totalVat: 'Загалом ПДВ',
            total: 'Разом',
            billTo: 'Покупець',
            shipTo: 'Адреса доставки',
            from: 'Від',
            to: 'Кому',
            date: 'Дата',
            dueDate: 'Термін оплати',
            invoiceNumber: 'Рахунок №',
            orderNumber: 'Замовлення №',
            reference: 'Посилання',
            details: 'Деталі',
            customer: 'Клієнт',
            vendor: 'Постачальник',
            subtotal: 'Проміжний підсумок',
            shipping: 'Доставка',
            discount: 'Знижка',
            tax: 'Податок',
            paid: 'Сплачено',
            balance: 'Залишок',
            credit: 'Кредит',
            bankDetails: 'Банківські реквізити',
            iban: 'IBAN',
            paymentTerms: 'Умови оплати',
            thankYou: 'Дякуємо за покупку!',
            notes: 'Примітки',
            terms: 'Умови',
            tracking: 'Відстеження',
            page: 'Сторінка',
            of: 'з',
        }
    },
    {
        code: 'zh',
        name: '中文 (Chinese)',
        font: 'Noto Sans SC',
        labels: {
            invoice: '发票',
            creditNote: '贷项通知单',
            quote: '报价单',
            estimate: '估价单',
            receipt: '收据',
            proforma: '形式发票',
            packingSlip: '装箱单',
            deliveryNote: '送货单',
            purchaseOrder: '采购订单',
            storno: '冲销发票',
            refund: '退款发票',
            description: '描述',
            item: '项目',
            qty: '数量',
            unitPrice: '单价',
            amount: '金额',
            gross: '含税',
            grossTotal: '含税合计',
            vat: '增值税',
            rate: '税率',
            net: '不含税',
            netTotal: '不含税合计',
            totalVat: '税额合计',
            total: '合计',
            billTo: '收票方',
            shipTo: '收货地址',
            from: '供应商',
            to: '客户',
            date: '日期',
            dueDate: '到期日',
            invoiceNumber: '发票号',
            orderNumber: '订单号',
            reference: '参考号',
            details: '详情',
            customer: '客户',
            vendor: '供应商',
            subtotal: '小计',
            shipping: '运费',
            discount: '折扣',
            tax: '税金',
            paid: '已付',
            balance: '余额',
            credit: '信用额',
            bankDetails: '银行信息',
            iban: 'IBAN',
            paymentTerms: '付款条件',
            thankYou: '感谢您的惠顾！',
            notes: '备注',
            terms: '条款与条件',
            tracking: '物流追踪',
            page: '第',
            of: '页，共',
        }
    },
    {
        code: 'ja',
        name: '日本語 (Japanese)',
        font: 'Noto Sans JP',
        labels: {
            invoice: '請求書',
            creditNote: 'クレジットノート',
            quote: '見積書',
            estimate: '概算見積',
            receipt: '領収書',
            proforma: 'プロフォーマインボイス',
            packingSlip: '梱包明細書',
            deliveryNote: '納品書',
            purchaseOrder: '注文書',
            storno: '取消請求書',
            refund: '返金請求書',
            description: '品名',
            item: '項目',
            qty: '数量',
            unitPrice: '単価',
            amount: '金額',
            gross: '税込',
            grossTotal: '税込合計',
            vat: '消費税',
            rate: '税率',
            net: '税抜',
            netTotal: '税抜合計',
            totalVat: '消費税合計',
            total: '合計',
            billTo: '請求先',
            shipTo: '送付先',
            from: '差出人',
            to: '宛先',
            date: '日付',
            dueDate: '支払期限',
            invoiceNumber: '請求書番号',
            orderNumber: '注文番号',
            reference: '参照番号',
            details: '明細',
            customer: 'お客様',
            vendor: '取引先',
            subtotal: '小計',
            shipping: '送料',
            discount: '値引き',
            tax: '税金',
            paid: '入金済',
            balance: '残高',
            credit: 'クレジット',
            bankDetails: '振込先',
            iban: 'IBAN',
            paymentTerms: 'お支払い条件',
            thankYou: 'ご利用ありがとうございます。',
            notes: '備考',
            terms: '取引条件',
            tracking: '追跡番号',
            page: 'ページ',
            of: '/',
        }
    },
    {
        code: 'ar',
        name: 'العربية (Arabic)',
        font: 'Noto Sans Arabic',
        direction: 'rtl',
        labels: {
            invoice: 'فاتورة',
            creditNote: 'إشعار دائن',
            quote: 'عرض سعر',
            estimate: 'تقدير',
            receipt: 'إيصال',
            proforma: 'فاتورة أولية',
            packingSlip: 'بيان التعبئة',
            deliveryNote: 'إشعار تسليم',
            purchaseOrder: 'أمر شراء',
            storno: 'فاتورة ملغاة',
            refund: 'فاتورة استرداد',
            description: 'الوصف',
            item: 'الصنف',
            qty: 'الكمية',
            unitPrice: 'سعر الوحدة',
            amount: 'المبلغ',
            gross: 'إجمالي',
            grossTotal: 'الإجمالي شامل',
            vat: 'ض.ق.م',
            rate: 'النسبة',
            net: 'صافي',
            netTotal: 'الصافي',
            totalVat: 'إجمالي الضريبة',
            total: 'المجموع',
            billTo: 'فاتورة إلى',
            shipTo: 'شحن إلى',
            from: 'من',
            to: 'إلى',
            date: 'التاريخ',
            dueDate: 'تاريخ الاستحقاق',
            invoiceNumber: 'رقم الفاتورة',
            orderNumber: 'رقم الطلب',
            reference: 'المرجع',
            details: 'التفاصيل',
            customer: 'العميل',
            vendor: 'المورد',
            subtotal: 'المجموع الفرعي',
            shipping: 'الشحن',
            discount: 'الخصم',
            tax: 'الضريبة',
            paid: 'مدفوع',
            balance: 'الرصيد',
            credit: 'رصيد دائن',
            bankDetails: 'التفاصيل البنكية',
            iban: 'IBAN',
            paymentTerms: 'شروط الدفع',
            thankYou: '!شكراً لتعاملكم معنا',
            notes: 'ملاحظات',
            terms: 'الشروط والأحكام',
            tracking: 'التتبع',
            page: 'صفحة',
            of: 'من',
        }
    },
];

const LABEL_FIELDS = [
    { category: 'Document Types', fields: [
        { key: 'invoice', label: 'Invoice' },
        { key: 'creditNote', label: 'Credit Note' },
        { key: 'quote', label: 'Quote' },
        { key: 'estimate', label: 'Estimate' },
        { key: 'receipt', label: 'Receipt' },
        { key: 'proforma', label: 'Proforma' },
        { key: 'packingSlip', label: 'Packing Slip' },
        { key: 'deliveryNote', label: 'Delivery Note' },
        { key: 'purchaseOrder', label: 'Purchase Order' },
        { key: 'storno', label: 'Storno' },
        { key: 'refund', label: 'Refund' },
    ]},
    { category: 'Table Headers', fields: [
        { key: 'description', label: 'Description' },
        { key: 'item', label: 'Item' },
        { key: 'qty', label: 'Quantity' },
        { key: 'unitPrice', label: 'Unit Price' },
        { key: 'amount', label: 'Amount' },
        { key: 'gross', label: 'Gross' },
        { key: 'grossTotal', label: 'Gross Total' },
        { key: 'vat', label: 'VAT/Tax' },
        { key: 'rate', label: 'Rate' },
        { key: 'net', label: 'Net' },
        { key: 'netTotal', label: 'Net Total' },
        { key: 'totalVat', label: 'Total VAT' },
        { key: 'total', label: 'Total' },
    ]},
    { category: 'Sections', fields: [
        { key: 'billTo', label: 'Bill To' },
        { key: 'shipTo', label: 'Ship To' },
        { key: 'from', label: 'From' },
        { key: 'to', label: 'To' },
        { key: 'date', label: 'Date' },
        { key: 'dueDate', label: 'Due Date' },
        { key: 'invoiceNumber', label: 'Invoice Number' },
        { key: 'orderNumber', label: 'Order Number' },
        { key: 'reference', label: 'Reference' },
        { key: 'details', label: 'Details' },
        { key: 'customer', label: 'Customer' },
        { key: 'vendor', label: 'Vendor' },
    ]},
    { category: 'Totals', fields: [
        { key: 'subtotal', label: 'Subtotal' },
        { key: 'shipping', label: 'Shipping' },
        { key: 'discount', label: 'Discount' },
        { key: 'tax', label: 'Tax' },
        { key: 'paid', label: 'Paid' },
        { key: 'balance', label: 'Balance' },
        { key: 'credit', label: 'Credit' },
    ]},
    { category: 'Footer', fields: [
        { key: 'bankDetails', label: 'Bank Details' },
        { key: 'iban', label: 'IBAN' },
        { key: 'paymentTerms', label: 'Payment Terms' },
        { key: 'thankYou', label: 'Thank You Message' },
        { key: 'notes', label: 'Notes' },
        { key: 'terms', label: 'Terms' },
        { key: 'tracking', label: 'Tracking' },
    ]},
    { category: 'Pagination', fields: [
        { key: 'page', label: 'Page' },
        { key: 'of', label: 'Of' },
    ]},
];

module.exports = { defaultLabels, LANGUAGE_PRESETS, LABEL_FIELDS };



// WEBPACK FOOTER //
// config/template_labels.js